import { render, staticRenderFns } from "./DrugLandingClickView.vue?vue&type=template&id=d594871a&"
import script from "./DrugLandingClickView.vue?vue&type=script&lang=js&"
export * from "./DrugLandingClickView.vue?vue&type=script&lang=js&"
import style0 from "./DrugLandingClickView.vue?vue&type=style&index=0&id=d594871a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d594871a')) {
      api.createRecord('d594871a', component.options)
    } else {
      api.reload('d594871a', component.options)
    }
    module.hot.accept("./DrugLandingClickView.vue?vue&type=template&id=d594871a&", function () {
      api.rerender('d594871a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/statistics/druglanding-stast-view/DrugLandingClickView.vue"
export default component.exports